import { useParams } from "react-router";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { PolicyPdfData } from "./PolicyPdf.types";

export default function usePolicyPdfHooks() {
    const { policyId, versionId } = useParams<{ policyId: string; versionId: string }>();
    const url = `/policies/${policyId}/versions/${versionId}/pdf-data`;
    const { data, isLoading } = useDotLegalQuery<PolicyPdfData>(url);
    return { data, isLoading };
}
